import { Component, Prop, Mixins } from 'vue-property-decorator';

@Component
/**
 * Footer Props
 */
export default class Props extends Mixins() {
    /**
     * Classes
     */
    @Prop({ type: String }) classes!: string | Array<string>;

    /**
     * Site Logo
     */
    @Prop({ type: String }) siteLogo!: string;

    /**
     * Site Title
     */
    @Prop({ type: String }) siteTitle!: string;

    /**
     * Site Description
     */
    @Prop({ type: String }) siteDescription!: string;

    /**
     * Menu
     */
    @Prop({ type: Array }) menu!: object | Array<string>;

    /**
     * 2nd Menu
     */
    @Prop({ type: Array }) secondMenu!: object | Array<string>;

    /**
     * Menu Title
     */
    @Prop({ type: String }) menuTitle!: string;

    /**
     * 2nd Menu Title
     */
    @Prop({ type: String }) secondMenuTitle!: string;

    /**
     * Contact Title
     */
    @Prop({ type: String }) contactTitle!: string;

    /**
     * Site contact details
     */
    @Prop() contactDetails!: object | string;

    /**
     * Contact details text
     */
    @Prop({ type: String }) contactDetailsText!: string;

    /**
     * Socials media title
     */
    @Prop({ type: String }) socialsTitle!: string;

    /**
     * Socials Media link
     */
    @Prop() socialsLinks!: object | string;

    /**
     * trustSeal
     */
    @Prop({ type: Array }) trustSeal!: Array<{ [k: string]: any }>;

    /**
     * trustSeal Title
     */
    @Prop({ type: String }) trustSealTitle!: string;

    /**
     * Copy Right text
     */
    @Prop({ type: String }) copyRightText!: string;

    /**
     * Powered by link
     */
    @Prop({ type: String }) poweredByLink!: string;

    /**
     * Powered by text
     */
    @Prop({ type: String }) poweredByText!: string;

    /**
     * section items
     */
    @Prop({ type: [Object, Array] }) sectionItems!: object | Array<object>;

    /**
     * Footer background color
     */
    @Prop({ type: String }) backgroundColor!: string;

    /**
     * Footer title color
     */
    @Prop({ type: String }) color!: string;
}
